import ReqError, {LogicExceptionList} from "@source/api/reqError";
import {api} from "@source/api/http";
import {
  ICreateNursingHomeRequest,
  ICreateNursingHomeResponse,
  IEditNursingHomeRequest,
  IEditNursingHomeResponse,
  IGetAvailableNursingHomesRequest,
  IGetAvailableNursingHomesResponse,
  IGetNewResidentsReq,
  IGetNursingHomeResponse,
  IGetNursingHomesRequest,
  IGetNursingHomesResponse,
  IGetOrganizationsReq,
  IGetOrganizationsResponse,
  IOrganization
} from "@source/api/models/nursingHomeModels";
import {IResident} from "@source/api/models/residentModel";

export default class NursingHomeService {
  static async getNursingHome(nursingHomeId: string) {
    try {
      return (await api.get<IGetNursingHomeResponse>(`nursingHome/${nursingHomeId}`)).data
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.getNursingHomeError(e.response)
    }
  }
  
  static async createNursingHome(req: ICreateNursingHomeRequest) {
    try {
      return (await api.post<ICreateNursingHomeResponse>('nursingHome', {...req})).data
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.createNursingHomeError(e.response)
    }
  }

  static async editNursingHome(req: IEditNursingHomeRequest, nursingHomeId: string) {
    try {
      return (await api.put<IEditNursingHomeResponse>(`nursingHome/${nursingHomeId}`, {...req})).data
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.editNursingHomeError(e.response)
    }
  }
  
  static async editNursingHomePhoto(req: FormData, nursingHomeId: string) {
    try {
      return (await api.patch<string>(`nursingHome/${nursingHomeId}/photo`, req)).data
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.editNursingHomePhotoError(e.response)
    }
  }

  static async getNursingHomes({searchString = "", organizationId, limit = 100, page = 0}: IGetNursingHomesRequest) {
    try {
      return (await api.get<IGetNursingHomesResponse>(`nursingHome?searchString=${searchString}&organizationId=${organizationId}&limit=${limit}&page=${page}`)).data
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.createNursingHomeError(e.response)
    }
  }

  static async getAvailableNursingHomes({organizationId}: IGetAvailableNursingHomesRequest) {
    try {
      return (await api.get<IGetAvailableNursingHomesResponse[]>(`nursingHome/available/employee?organizationId=${organizationId}`)).data
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.getAvailableNursingHomesError(e.response)
    }
  }

  static async getOrganizations({searchString = '', limit = 25, page = 0}: IGetOrganizationsReq) {
    try {
      return (await api.get<IGetOrganizationsResponse>(`organization?searchString=${searchString}&limit=${limit}&page=${page}`)).data
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.getOrganizationsError(e.response)
    }
  }

  static async getNewResidentActivated(req: IGetNewResidentsReq) {
    try {
      return (await api.get<IResident[]>(`employee/home-checks/${req.homeId}/last-activated-residents`)).data
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.getOrganizationsError(e.response)
    }
  }

    static async getOrganizationByName(name: string) {
      try {
        const organization = (await api.get<IOrganization>(`organization/${name}/by-name`)).data
        if(!organization) {
          throw Error(`Organisation "${name}" not found. Please make sure you are using the correct login link`)
        }
        return organization
      } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
        throw ReqError.getOrganizationsError(e.response || { data: {message: e.message }})
      }
    }
}